import serverConfig from "config/server";

export const shouldInjectRobotsMeta = () => {
  const notProd = serverConfig.env !== "prod";
  const notLocal = serverConfig.env !== "local-dev";
  const notTest = serverConfig.env !== "ci";

  return notProd && notLocal && notTest;
};
